export default "__VITE_ASSET__d09b7dbd__"